import React from 'react';
import ErrorModal from '../Common/ErrorModal';

const NotFound = () => {
  return <ErrorModal errorMsg="Uh oh! It looks like the page you're looking for doesn't exist." />;
};

export default NotFound;
